import { Box, Button } from "@mui/material";

 const MultimediaCTAButtons = ({editableMultimediaData, multimediaData, handleMultimediaCTAButtonsClick}) => {

        return (
            <Box display="flex" flexDirection="row" gap={1} mt={1}>
                <Button
                    variant="contained"
                    color="error"
                    fullWidth
                    sx={{ height: 50, backgroundColor: "red", color: 'white', fontSize: 16 }}
                    onClick={() => {
                        handleMultimediaCTAButtonsClick("delete")
                    }}
                // disabled={!isValidNew}
                >Delete</Button>

                <Button
                    variant="contained"
                    color="error"
                    fullWidth
                    sx={{ height: 50, backgroundColor: "#a855f7", color: 'white', fontSize: 16 }}
                    onClick={() => {
                        handleMultimediaCTAButtonsClick("update")
                    }}
                // disabled={!isValidNew}
                >{"update"}</Button>
            </Box>
        );
    }

export default MultimediaCTAButtons;